var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.234375 18.8059C0.09375 19.928 0 21.0689 0 22.2285C0 32.4216 5.59688 41.2962 13.8844 46L15.4313 42.7457V20.5172L13.7156 18.8059H0.234375ZM48 20.5172C48 18.8059 46.2844 17.0945 44.5687 17.0945H30.8531C31.7063 13.6719 32.5687 10.2586 32.5687 8.54727C32.5687 5.12462 30.8531 1.71132 30 0.850986C29.9813 0.832283 29.1469 0 27.4313 0C24.8625 0 24.8625 2.56231 24.8625 2.56231C24.8625 2.60907 24.0094 6.83594 24.0094 8.54727C24.0094 10.2586 20.5781 17.0945 18.8625 18.8059L17.1469 19.6568V43.5967L18.8625 44.4477H37.7156C41.1469 44.4477 42.8625 42.7363 42.8625 41.025C42.8625 39.3137 41.1469 37.6024 39.4313 37.6024C42.8625 37.6024 44.5781 35.891 44.5781 34.1797C44.5781 32.4684 42.8625 30.7571 41.1469 30.7571C44.5781 30.7571 46.2937 29.0457 46.2937 27.3344C46.2937 25.6231 44.5781 23.9118 42.8625 23.9118C46.2844 23.9398 48 22.2285 48 20.5172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.44c4689d1debc808a12ea06fb56e05f9.svg";
export { ForwardRef as ReactComponent };